import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { SPACE_ID } from "@iscr/contentful/constants";
import ContentWrapper from "@iscr/contentful/ContentWrapper";
import { ContentfulProvider } from "@iscr/contentful/useContentful";
function ContentfulPage({ preview = false, contentTag, identifier, isStatic = false, parsedFunctions = {}, onHrefClicked, }) {
    const navigate = useNavigate();
    const handleClick = useCallback((e) => {
        const anchor = e.target.closest("a");
        if (!anchor)
            return;
        const href = anchor.getAttribute("href");
        if (!href || (onHrefClicked === null || onHrefClicked === void 0 ? void 0 : onHrefClicked(href)) || href.startsWith("#") || e.defaultPrevented) {
            return;
        }
        if (/^https?:\/\//i.test(href)) {
            try {
                const parsed = new URL(href);
                const ownHosts = [
                    "www.instantscripts.com.au",
                    "app.instantscripts.com.au",
                    window.location.host,
                ];
                if (!ownHosts.includes(parsed.host))
                    return;
                e.preventDefault();
                navigate(parsed.pathname + parsed.search + parsed.hash);
            }
            catch (_a) {
                // malformed URL - let browser handle
            }
            return;
        }
        // Non-path protocols (mailto:, tel:, javascript:, etc.) - let browser handle
        if (/^[a-z][a-z0-9+\-.]*:/i.test(href))
            return;
        e.preventDefault();
        navigate(href);
    }, [navigate]);
    return (_jsx(ContentfulProvider, { space: SPACE_ID, preview: preview, children: _jsx("div", { onClick: handleClick, children: _jsx(ContentWrapper, { preview: preview, contentTag: contentTag, identifier: identifier, isStatic: isStatic, parsedFunctions: parsedFunctions }) }) }));
}
export default ContentfulPage;
